const STORAGE_PREFIX = 'saloon_online_booking_toast_seen_'

/**
 * @param {number | null | undefined} branchId
 * @returns {Set<number>}
 */
export function getToastSeenBookingIds(branchId) {
  if (!branchId) {
    return new Set()
  }

  try {
    const raw = sessionStorage.getItem(`${STORAGE_PREFIX}${branchId}`)
    if (!raw) {
      return new Set()
    }

    const parsed = JSON.parse(raw)
    if (!Array.isArray(parsed)) {
      return new Set()
    }

    return new Set(parsed.map((value) => Number(value)).filter((value) => Number.isFinite(value)))
  } catch {
    return new Set()
  }
}

/**
 * @param {number | null | undefined} branchId
 * @param {number[]} appointmentIds
 */
export function markToastSeenBookingIds(branchId, appointmentIds) {
  if (!branchId || appointmentIds.length === 0) {
    return
  }

  const seen = getToastSeenBookingIds(branchId)
  appointmentIds.forEach((id) => seen.add(id))
  sessionStorage.setItem(`${STORAGE_PREFIX}${branchId}`, JSON.stringify([...seen]))
}
